import React from 'react';

export const Expand = ({
  className,
  color,
  height,
}: {
  className?: string;
  color?: string;
  height?: string;
}) => (
  <svg
    width={height ?? '24'}
    height={height ?? '25'}
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="24"
      height="24"
      transform="translate(0 0.962646)"
      fill="white"
      fillOpacity="0.01"
    />
    <path
      d="M18.062 11.9628L16.5 10.8768C16.4045 10.7845 16.3283 10.6742 16.2759 10.5522C16.2235 10.4302 16.1959 10.2989 16.1947 10.1662C16.1936 10.0334 16.2189 9.9017 16.2692 9.7788C16.3195 9.65591 16.3937 9.54426 16.4876 9.45036C16.5815 9.35647 16.6931 9.28222 16.816 9.23194C16.9389 9.18166 17.0706 9.15635 17.2034 9.15751C17.3362 9.15866 17.4674 9.18625 17.5894 9.23866C17.7114 9.29107 17.8218 9.36725 17.914 9.46276L20.53 12.0788C20.81 12.2458 21 12.5788 21 12.9628C21 13.3468 20.81 13.6798 20.53 13.8468L17.914 16.4628C17.7254 16.6449 17.4728 16.7457 17.2106 16.7434C16.9484 16.7412 16.6976 16.636 16.5122 16.4506C16.3268 16.2652 16.2216 16.0144 16.2193 15.7522C16.217 15.49 16.3178 15.2374 16.5 15.0488L18.062 13.9628H14.382C13.895 13.9628 13.5 13.5148 13.5 12.9628C13.5 12.4108 13.895 11.9628 14.382 11.9628H18.062ZM3.47 13.8468C3.19 13.6798 3 13.3468 3 12.9628C3 12.5788 3.19 12.2458 3.47 12.0788L6.086 9.46276C6.2746 9.2806 6.5272 9.17981 6.7894 9.18208C7.0516 9.18436 7.30241 9.28953 7.48782 9.47494C7.67323 9.66035 7.7784 9.91116 7.78067 10.1734C7.78295 10.4356 7.68216 10.6882 7.5 10.8768L5.938 11.9628H9.618C10.105 11.9628 10.5 12.4108 10.5 12.9628C10.5 13.5148 10.105 13.9628 9.618 13.9628H5.938L7.5 15.0488C7.68216 15.2374 7.78295 15.49 7.78067 15.7522C7.7784 16.0144 7.67323 16.2652 7.48782 16.4506C7.30241 16.636 7.0516 16.7412 6.7894 16.7434C6.5272 16.7457 6.2746 16.6449 6.086 16.4628L3.47 13.8468Z"
      fill={color || '#344563'}
    />
  </svg>
);
